import { useEffect } from 'react';
import { useRecoilState } from 'recoil';

import { CURRENT_LIVE_VIDEO_STREAM } from '@constants';
import { liveVideoPlayerState } from '@store';

import { getStorageItem, setStorageItem } from '../helpers/storage';
import { CurrentLiveStreamType } from '../store/types/LiveVideoPlayerStateType';

export const liveVideoStreamTypes: Record<string, CurrentLiveStreamType> = {
  videoStream: 'video_stream',
  videoStreamSpanish: 'video_stream_spanish',
  videoStreamPattrn: 'video_stream_pattrn',
};

export const useLiveStreamSelector = () => {
  const [liveVideoState, setLiveVideoState] = useRecoilState(liveVideoPlayerState);

  const getCurrentLiveVideoStream = async () => {
    const currentLiveVideoStream = await getStorageItem(CURRENT_LIVE_VIDEO_STREAM);

    if (currentLiveVideoStream) {
      setLiveVideoState({
        ...liveVideoState,
        currentLiveVideoStream,
      });
    }
  };

  useEffect(() => {
    getCurrentLiveVideoStream();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setCurrentLiveVideoStream = (type: CurrentLiveStreamType) => {
    const { currentLiveVideoStream } = liveVideoState;

    if (currentLiveVideoStream !== type) {
      setLiveVideoState(currentLiveVideoState => ({
        ...currentLiveVideoState,
        currentLiveVideoStream: type,
      }));
      setStorageItem(CURRENT_LIVE_VIDEO_STREAM, type);
    }
  };

  return {
    setCurrentLiveVideoStream,
    liveVideoStreamTypes,
    liveVideoState,
  };
};
